// extracted by mini-css-extract-plugin
module.exports =  {"thumbnail":"JFJgmToXElEo5lO_80Fn"};